import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lib-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent  {
  @Output() hideError: EventEmitter<any> = new EventEmitter();
  @Input() errorText: string;

  onClick() {
    this.hideError.emit();
  }
}
